export const translateIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0L5.5 4h3.75v5.25H4V5.5L0 10l4 4.5v-3.75h5.25V16H5.5l4.5 4 4.5-4h-3.75v-5.25H16v3.75l4-4.5-4-4.5v3.75h-5.25V4h3.75z"/></svg>`,
  name: 'translate',
};
